import { useContext } from "react";
import { clientBulkActionsContext } from "./clientBulkActionsContext";

export function useClientBulkActions() {
    return useContext(clientBulkActionsContext);
}
